export var extractDateCreated = function extractDateCreated(jsonLd) {
  if (jsonLd['schema:dateCreated']) {
    return jsonLd['schema:dateCreated'];
  }
};